import React from 'react';

import { useTranslation } from 'react-i18next';
import { Box, Slide, Typography } from '@mui/material';
import GridItem from '@jumbo/components/GridItem';
import GridContainer from '@jumbo/components/GridContainer';
import StorePageHeader from 'Components/StorePageHeader';

const ExteriorSignageQuoteLandingInfo = () => {
  const { t } = useTranslation();

  return (
    <Slide direction="up" in mountOnEnter unmountOnExit>
      <Box>
        <StorePageHeader
          title={t('exteriorSignage')}
          imgSrc={'/images/headers/ExteriorSignage.jpg'}
          imgLeft
          backgroundColor="lightGray"
          borderRadius="0.5rem"
          height="350px"
        />

        <GridContainer sx={{ mt: 1, px: 6, mb: 6 }}>
          <GridItem xs={12}>
            <Typography sx={{ mt: 2 }} variant="h2" style={{ fontWeight: 'bold' }}>
              {t('exteriorSignageTempTitle')}
            </Typography>
            <Typography sx={{ mt: 2 }} variant="h3" style={{ fontWeight: 'normal' }} color={'primary'}>
              {t('exteriorSignageTempLine1')}
            </Typography>
            <Typography sx={{ mt: 2 }} variant="h3" style={{ fontWeight: 'normal' }} color={'primary'}>
              {t('exteriorSignageTempLine2')}
            </Typography>
          </GridItem>
        </GridContainer>
      </Box>
    </Slide>
  );
};

export default ExteriorSignageQuoteLandingInfo;
